import {useQuery} from "@apollo/client";
import {AssetTabInfo} from "../../graphql/queries/assetTabInfo";
import _ from "lodash";
import {CircularProgress, Typography} from "@mui/joy";
import {CloseRounded} from "@mui-symbols-material/w300";
import {useTranslation} from "react-i18next";

interface Props {
    assetLocationId: string,
    activeTab?: boolean
    onCloseTab?: (assetLocationId: string) => void,
}

const AssetTabTitle = ({assetLocationId, activeTab, onCloseTab}: Props) => {

    const {t } = useTranslation();

    const assetTabInfoQuery = useQuery(AssetTabInfo, {
        variables: {
            id: assetLocationId
        }
    })

    const handleTabClose = (e: any, id: string) => {
        e.stopPropagation()
        if (onCloseTab) onCloseTab(id)
    }

    let label = <CircularProgress size="sm" />

    if (!assetTabInfoQuery.loading) {
        const installedBaseNodeTitle = _.get(assetTabInfoQuery, 'data.assetLocation.installedBaseNode.title')
        const productName = _.get(assetTabInfoQuery, 'data.assetLocation.asset.product.name')
        const title = installedBaseNodeTitle || productName || t("N/A")

        label = <Typography noWrap sx={{maxWidth: 280}} fontWeight={activeTab ? "bold" : "normal"} level={"body-md"}>
            {title}
        </Typography>
    }

    if (onCloseTab) {
        label = <div className={"flex-row flex-align-items-center"}>
            {label}
            <CloseRounded
                sx={{ color: '#666', marginLeft: '8px', fontSize: '16px', fontWeight: 'normal' }}
                onClick={(event) => handleTabClose(event, assetLocationId)}
            />
        </div>
    }

    return label
}

export default AssetTabTitle;
